import React from 'react';
import styled from 'styled-components';
import { blueLightCardImages } from '../../Theming/images';

const StepContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 50px;
`;

const StepContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  max-width: 400px;
`;

const StepNumber = styled.div`
  font-family: 'Museo Sans', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #202125;
  flex-shrink: 0;
  width: 5px;
`;

const StepText = styled.div`
  font-family: 'Museo Sans', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #202125;
  flex: 1;
  padding-right: 12px;
`;

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0px;
  flex-shrink: 0;
`;

const StepImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const ArrowImage = styled.img`
  width: 40px;
  height: auto;
`;

interface ActivationStepProps {
  stepNumber: number;
  text: React.ReactNode;
  imageSrc: string;
  showArrow?: boolean;
}

const ActivationStep: React.FC<ActivationStepProps> = ({
  stepNumber,
  text,
  imageSrc,
  showArrow = true,
}) => {
  return (
    <StepContainer>
      <StepContent>
        <StepNumber>{stepNumber}.</StepNumber>
        <StepText>{text}</StepText>
        <ImageContainer>
          <StepImage src={imageSrc} alt={`Step ${stepNumber}`} />
          {showArrow && (
            <ArrowImage
              src={blueLightCardImages.safari_setting_partial_arrow}
              alt="arrow"
            />
          )}
        </ImageContainer>
      </StepContent>
    </StepContainer>
  );
};

export default ActivationStep;
